export const privacyAgreement = "privacy";
export const paidServiceAgreement = "paid-service";
export const termsAndConditionsAgreement = "terms-and-conditions";
export const communityGuidelinesAgreement = "community-guidelines";

export const agreements = {
  [privacyAgreement]: "April 15, 2025",
  [paidServiceAgreement]: undefined,
  [termsAndConditionsAgreement]: "April 15, 2025",
  [communityGuidelinesAgreement]: "April 15, 2025",
};
